import { Http } from "../Http";
import { InsuranceDoctorNoteDto } from "@apiModels/Insurance/InsuranceDoctorNoteDto.csharp";

export interface IDoctorNotesApi {
  addNewNote(note: string, doctorId: string): Promise<InsuranceDoctorNoteDto>;
  deleteNote(noteId: string): Promise<void>;
  editNote(note: InsuranceDoctorNoteDto): Promise<InsuranceDoctorNoteDto>
}

export class DoctorNotesApi implements IDoctorNotesApi {
  public addNewNote = (note: string, doctorId: string): Promise<InsuranceDoctorNoteDto> => {
    return Http.post(`/api/doctors/insurance/notes/${doctorId}`, note) as Promise<InsuranceDoctorNoteDto>;
  };
  public editNote = (note: InsuranceDoctorNoteDto): Promise<InsuranceDoctorNoteDto> => {
    return Http.patch(`/api/doctors/insurance/notes/${note.id}`, note.text) as Promise<InsuranceDoctorNoteDto>;
  };
  public deleteNote = (noteId: string): Promise<void> => {
    return Http.delete(`/api/doctors/insurance/notes/${noteId}`) as Promise<void>;
  };
}